/**
 * Whether the user holds any paid access, mirroring the backend's `User::hasAnyAccess()`.
 *
 * Label scanning is gated on ANY paid access (diet / workout / AI), not on the AI plan alone —
 * `ScanLabelResolver` returns `AiAccessDenied` on the same condition. Keeping the two in step
 * matters: a front end that is stricter than the server hides a feature the user has paid for.
 *
 * All three keys are written by `UserDataConnectorApollo` after login, each from its own field on
 * `me`: `aiAccess.hasAccess`, `diet.accessTo` and `videoWorkout.accessTo`.
 *
 * In the native webview none of these keys are set — the app opens the webview straight on the
 * target URL, so no screen that writes them has mounted. `mobileAppMode` therefore bypasses this
 * check entirely at the call site.
 */
export const hasAnyPaidAccess = (): boolean => {
  try {
    return (
      sessionStorage.getItem('aiAccess') === 'true' ||
      sessionStorage.getItem('dietAccess') === 'true' ||
      sessionStorage.getItem('workoutAccess') === 'true'
    );
  } catch {
    // Private-mode Safari can throw on storage access; fall back to "no access" and let the
    // backend decide, rather than crashing the screen.
    return false;
  }
};
